var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQa = function SvgQa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 480",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-27.334 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "matrix(.9 0 0 .9 25.6 0)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#660057",
    d: "M-70 0h768v512H-70z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.533 511.76l-156.53.24L-70 0 85.8.08l100.53 32.33-99.795 31.51 99.79 32.49-99.79 31.51 99.79 32.49-99.79 31.51 99.79 32.49-99.79 31.51 99.79 32.49-99.79 31.51 99.79 32.49-99.79 31.512 99.79 32.49-99.79 31.51 99.79 32.49-99.79 31.51",
    fill: "#fff"
  }))));
};
export default SvgQa;